import { Pet } from "../types";

export const comparePetsByName = (petA: Pet, petB: Pet) => {
  const petAName = petA.name.toUpperCase();
  const petBName = petB.name.toUpperCase();
  if (petAName < petBName) {
    return -1;
  }
  if (petAName > petBName) {
    return 1;
  }

  return 0;
};
